<template>
  <div>

      <Banner></Banner>

      <BrandsLogos></BrandsLogos>

      <About></About>

      <Vistion></Vistion>

      <Advantages></Advantages>

      <WhyChooseUs></WhyChooseUs>

      <TypeDiv></TypeDiv>

      <Portfolio></Portfolio>

      <Const></Const>

  </div>
</template>

<script>
import Banner from '../../components/WebDevelopment/PHPDevelopment/Banner.vue'
import Vistion from '../../components/WebDevelopment/PHPDevelopment/Vistion.vue'
import Advantages from '../../components/WebDevelopment/PHPDevelopment/Advantages.vue'
import WhyChooseUs from '../../components/WebDevelopment/PHPDevelopment/WhyChooseUs.vue'
import BrandsLogos from '../../components/AssetComponents/BrandsLogos.vue'
import Portfolio from '../../components/Home/Portfolio.vue'
import About from '../../components/WebDevelopment/PHPDevelopment/About.vue'
import TypeDiv from '../../components/Home/TypeDiv.vue'
import Const from '../../components/AssetComponents/Const.vue'

export default {
    components:{
        Banner,
        BrandsLogos,
        About,
        TypeDiv,
        WhyChooseUs,
        Portfolio,
        Const,
        Vistion,
        Advantages
    }
}
</script>


<style>

</style>